export const ADD_ITERATE_BY = 'REPORTING_ADD_ITERATE_BY';

export const addIterateBy = iterateByValues => ({
  type: ADD_ITERATE_BY,
  iterateByValues,
});
